import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import axios from "axios";
import { API } from "@/lib/api";
import { Check, Info, X } from "lucide-react";

export default function Confirmer() {
  const [params] = useSearchParams();
  const jeton = params.get("jeton");
  const [state, setState] = useState({ status: "loading", data: {} });

  useEffect(() => {
    if (!jeton) {
      setState({ status: "invalide", data: { message: "Lien de confirmation invalide (jeton manquant)." } });
      return;
    }
    axios
      .post(`${API}/confirmer`, { jeton })
      .then((r) => setState({ status: r.data.status, data: r.data }))
      .catch(() => setState({ status: "reseau", data: {} }));
  }, [jeton]);

  const lieu = state.data.commune
    ? `${state.data.commune}${state.data.departement ? ` (${state.data.departement})` : ""}`
    : "votre commune";

  return (
    <div data-testid="screen-confirmer" style={{ maxWidth: 560 }}>
      <h1 style={{ fontSize: "1.6rem" }}>Confirmation d'inscription</h1>

      {state.status === "loading" && (
        <p data-testid="confirmer-loading" style={{ color: "var(--muted)" }}>Traitement…</p>
      )}

      {state.status === "confirme" && (
        <div className="pc-card" data-testid="confirmer-success" style={{ background: "var(--accent-soft)", borderColor: "var(--accent)" }}>
          <div style={{ display: "flex", gap: "0.6rem", alignItems: "flex-start" }}>
            <Check size={20} color="var(--accent)" style={{ marginTop: 2 }} />
            <div>
              <p style={{ margin: 0 }}>
                C'est confirmé : la veille est active pour <strong>{lieu}</strong>.
              </p>
              <p style={{ margin: "0.6rem 0 0" }}>
                Aucun e-mail ne vous sera envoyé tant qu'aucun arrêté de reconnaissance de
                l'état de catastrophe naturelle ne concernera cette commune. Le jour où cela
                arrivera, vous recevrez une alerte avec la date limite de déclaration.
              </p>
            </div>
          </div>
        </div>
      )}

      {state.status === "deja_confirme" && (
        <div className="pc-card" data-testid="confirmer-already" style={{ background: "var(--accent-soft)", borderColor: "var(--accent)" }}>
          <div style={{ display: "flex", gap: "0.6rem", alignItems: "flex-start" }}>
            <Info size={20} color="var(--accent)" style={{ marginTop: 2 }} />
            <div>
              <p style={{ margin: 0 }}>
                Votre inscription pour <strong>{lieu}</strong> est <strong>déjà confirmée</strong>.
                Vous n'avez rien de plus à faire.
              </p>
              <p style={{ margin: "0.6rem 0 0" }}>
                La veille est active : vous serez prévenu(e) dès qu'un arrêté concernera cette commune.
              </p>
            </div>
          </div>
        </div>
      )}

      {(state.status === "expire" || state.status === "invalide" || state.status === "reseau") && (
        <div className="pc-card" data-testid="confirmer-invalid" style={{ background: "var(--warn-soft)", borderColor: "#E4D8BE" }}>
          <div style={{ display: "flex", gap: "0.6rem", alignItems: "flex-start" }}>
            <X size={20} color="var(--warn)" style={{ marginTop: 2 }} />
            <div>
              <p style={{ margin: 0 }}>
                {state.status === "reseau"
                  ? "Une erreur est survenue. Réessayez dans un instant."
                  : "Ce lien de confirmation n'est plus valide : il est inconnu ou a expiré."}
              </p>
              {state.status !== "reseau" && (
                <p style={{ margin: "0.6rem 0 0" }}>
                  Pas d'inquiétude : vous pouvez refaire une inscription en quelques secondes.
                </p>
              )}
            </div>
          </div>
        </div>
      )}

      {(state.status === "expire" || state.status === "invalide") && (
        <p style={{ marginTop: "1.2rem" }}>
          <Link to="/" data-testid="confirmer-reinscription">Refaire une inscription</Link>
        </p>
      )}
      {(state.status === "confirme" || state.status === "deja_confirme" || state.status === "reseau") && (
        <p style={{ marginTop: "1.2rem" }}>
          <Link to="/" data-testid="confirmer-home">Retour à l'accueil</Link>
        </p>
      )}
    </div>
  );
}
